import script from "./DownloadView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DownloadView.vue?vue&type=script&setup=true&lang=ts"

import "./DownloadView.vue?vue&type=style&index=0&id=44de45c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44de45c0"]])

export default __exports__